import clsx from "clsx";
import Button, { TButtonSize } from "..";
import styles from "./styles.module.scss";

export interface IItemButtonGroup {
  onClick: () => void;
  variant: "dark" | "lightDark" | "lightGreen";
  label: string;
}

interface IGroupButtons {
  data: IItemButtonGroup[];
  isRowContainer?: boolean;
  size?: TButtonSize;
}

const GroupButtons = ({ data, isRowContainer, size }: IGroupButtons) => {
  return (
    <div className={styles.groupButtons}>
      <div
        className={clsx(
          styles.groupButtons__container,
          size === "small" && styles.groupButtons__container_gapSmall,
          isRowContainer && styles.groupButtons__container_row,
          isRowContainer &&
            size === "small" &&
            styles.groupButtons__container_rowSmall
        )}
      >
        {data.map((itemBtnGroup) => {
          return (
            <Button
              key={itemBtnGroup.label}
              label={itemBtnGroup.label}
              onClick={itemBtnGroup.onClick}
              variant={itemBtnGroup.variant}
              size={size}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GroupButtons;
